import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditingForm,
  setEditingForm,
  setEditingQuestionId,
} from "../../redux/features/appData/appDataSlice";
import "./FormThemeMenu.css";
import "../../css/Icons.css";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import { apiCreateQuestionForForm, apiDeleteQuestion, apiUpdateQuestionConditions } from "../../services/QuestionService";
import { CreateQuestionForFormPayload, Question, UpdateFormQuestionOrderPayload, UpdateQuestionConditionsPayload } from "effno-core";
import { apiUpdateFormQuestionOrder } from "../../services/FormService";
import { addNewQuestionToOrder } from "../shared/uiHelpers";
import { Condition } from "../workflow/questionWorkflowConditions";

const THEME_MENU = {
  EDIT: "delete",
  DELETE: "end_up",
  UNSELECT: "unselect",
};

type FormThemeMenuProps = {
    formThemeId: string;
    onEdit: (formThemeId: string) => void;
    onDelete: (formThemeId: string) => void;
    onUnselect?: () => void;
};

export default function FormThemeMenu({ formThemeId, onDelete, onEdit, onUnselect = undefined }: FormThemeMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // route it
    switch (selection) {
      case THEME_MENU.DELETE:
        handleDelete();
        break;
      case THEME_MENU.EDIT:
        handleEdit();
        break; 
      case THEME_MENU.UNSELECT:
        if (onUnselect) {
          onUnselect();
        }
        break;
      default:
    }
  };

  const handleDelete = () => {
    onDelete(formThemeId);
  }

  const handleEdit = () => {
    onEdit(formThemeId);
  }
  
  return (
    <>
      <div className="form-theme-menu" onClick={handleButtonClick}>
        <div className="form-theme-image">
          <img className="icon-three-dots-vertical" alt="" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        
        <MenuItem onClick={() => handleMenuSelection(THEME_MENU.DELETE)}>
            Delete
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(THEME_MENU.EDIT)}>
            Edit
        </MenuItem>
        {onUnselect && 
          <MenuItem onClick={() => handleMenuSelection(THEME_MENU.UNSELECT)}>
            Unselect
          </MenuItem>
        }

        
      </Menu>
    </>
  );
}
